import {UIEvents, useInjection, visibilityEffect} from "@dp-instant/ui";
import {IEventEmitter, TypesCore} from "@dp-instant/interfaces";
import {Localize} from "@dp-instant/i18n";
import {UIConstants} from "@game/ui/constants";
import {playUIClickSound} from "@game/helpers";
import {Images} from "@game/ui/images";
import cn from "classnames";
import "./DailyLeaderboardRewardPopup.less";

type DailyLeaderboardRewardPopupProps = {
    place: number;
    reward: number;
    onConfirm: () => void;
};

const PLACE_EMOJI = ["\u{1F947}", "\u{1F948}", "\u{1F949}"];

export const DailyLeaderboardRewardPopup = ({place, reward, onConfirm}: DailyLeaderboardRewardPopupProps) => {
    const [invisible] = visibilityEffect(UIConstants.popup.startDelay);
    const dispatcher = useInjection<IEventEmitter>(TypesCore.dispatcher);

    const placeTextRu = [`1 место!`, `2 место!`, `3 место!`];
    const placeTextEn = [`1st Place!`, `2nd Place!`, `3rd Place!`];

    const handleOk = () => {
        playUIClickSound();
        onConfirm();
        dispatcher.emit(UIEvents.POPUP, {id: null});
    };

    return (
        <div className="popups">
            <div className={cn("popup-daily-lb-reward", {invisible})}>
                <div className="popup-daily-lb-reward__emoji">{PLACE_EMOJI[place - 1] || "\u{1F3C6}"}</div>
                <div className="popup-daily-lb-reward__title">{Localize.get("ui-daily-lb-title", "Daily Rating")}</div>
                <div className="popup-daily-lb-reward__place">
                    {Localize.get(`ui-daily-lb-place-${place}`, placeTextEn[place - 1] || `#${place}`)}
                </div>
                <div className="popup-daily-lb-reward__amount">
                    +{reward} <Images.Star />
                </div>
                <button className="popup-daily-lb-reward__btn" onClick={handleOk}>
                    OK
                </button>
            </div>
        </div>
    );
};
